import { any, coerce, create, Describe, number, optional, record, string, type } from 'superstruct';

import { FormResponse } from '~extension/web2print/model/FormResponse';

export const FormResponseValidator: Describe<FormResponse> = type({
  status: string(),
  assetId: optional(string()),
  jobId: optional(coerce(number(), string(), val => (!!val ? parseInt(val) : undefined))),
  documentId: optional(coerce(number(), string(), val => (!!val ? parseInt(val) : undefined))),
  clientId: optional(coerce(number(), string(), val => (!!val ? parseInt(val) : undefined))),
  form_errors: optional(record(string(), any())),
});

export function makeFormResponse(raw: unknown) {
  try {
    const formResponse = create(raw, FormResponseValidator);
    return formResponse;
  } catch (err) {
    console.error(err);
  }
}
